module.exports = __webpack_public_path__ + "static/media/zoom.2a4682c8.svg";